<template>
  <div class="mb-6 lg:mb-12 text-xl font-bold text-text leading-tight">
    <span class="">{{ $t('title') }}</span>
    <span v-if="!!account_selected" class=""> {{ $t('in') }}
       <span class="bg-bg-contractor rounded py-1 px-2 -my-2 text-white">{{ account_selected.title }}</span>
       <span class="bg-bg-contractor rounded py-1 px-2 -my-2 ml-2 text-white
       hover:opacity-75 cursor-pointer transition duration-200"
             @click="$emit('clearAcc')">
       <font-awesome-icon icon="times"/>
       </span>
    </span>
  </div>
</template>

<script>
export default {
  name: "RecentTransactionsHead",
  props: ['account_selected'],
  i18n: {
    messages: {
      en: {
        title: 'Recent transactions',
        in: 'in'
      },
      ru: {
        title: 'Последние операции',
        in: 'через'
      }
    }
  }
}
</script>

<style scoped>

</style>